import React from 'react'

export default function Holiday() {
  return (
    <>
      <div className='container'>
        <h2 id='h2'>HOLIDAY LIST - 2026</h2>

        <table className="table">
          <thead>
            <tr>
              <th scope="col">Occasion</th>
              <th scope="col">Date</th>
              <th scope="col">Day</th>
            </tr>
          </thead>

          <tbody>

            <tr>
              <th>Winter Break Phase I</th>
              <td>01/01/2026 to 03/01/2026</td>
              <td>Thu - Sat</td>
            </tr>

            <tr>
              <th>Makar Sankranti</th>
              <td>14/01/2026</td>
              <td>Wed</td>
            </tr>

            <tr>
              <th>Republic Day</th>
              <td>26/01/2026</td>
              <td>Mon</td>
            </tr>

            <tr>
              <th>Sab-E-Barat</th>
              <td>04/02/2026</td>
              <td>Wed</td>
            </tr>

            <tr>
              <th>Maha Shivratri</th>
              <td>15/02/2026</td>
              <td>Sun</td>
            </tr>

            <tr>
              <th>Dol Yatra & Holi</th>
              <td>03/03/2026 to 04/03/2026</td>
              <td>Tue - Wed</td>
            </tr>

            <tr>
              <th>Eid-Ul-Fitr</th>
              <td>21/03/2026</td>
              <td>Sat</td>
            </tr>

            <tr>
              <th>Ram Navami</th>
              <td>26/03/2026</td>
              <td>Thu</td>
            </tr>

            <tr>
              <th>Mahavir Jayanti</th>
              <td>31/03/2026</td>
              <td>Tue</td>
            </tr>

            <tr>
              <th>Good Friday</th>
              <td>03/04/2026</td>
              <td>Fri</td>
            </tr>

            <tr>
              <th>Bengali New Year</th>
              <td>15/04/2026</td>
              <td>Wed</td>
            </tr>

            <tr>
              <th>Buddha Purnima</th>
              <td>01/05/2026</td>
              <td>Fri</td>
            </tr>

            <tr>
              <th>Summer Vacation</th>
              <td>11/05/2026 to 31/05/2026</td>
              <td>Mon - Sun</td>
            </tr>

            <tr>
              <th>Summer Vacation (Including Bakrid)</th>
              <td>01/06/2026 to 20/06/2026</td>
              <td>Mon - Sat</td>
            </tr>

            <tr>
              <th>Muharram</th>
              <td>26/06/2026</td>
              <td>Fri</td>
            </tr>

            <tr>
              <th>Independence Day</th>
              <td>15/08/2026</td>
              <td>Sat</td>
            </tr>

            <tr>
              <th>Manasa Puja</th>
              <td>17/08/2026</td>
              <td>Mon</td>
            </tr>

            <tr>
              <th>Milad-Un-Nabi</th>
              <td>26/08/2026</td>
              <td>Wed</td>
            </tr>

            <tr>
              <th>Raksha Bandhan</th>
              <td>28/08/2026</td>
              <td>Fri</td>
            </tr>

            <tr>
              <th>Janmashtami</th>
              <td>04/09/2026</td>
              <td>Fri</td>
            </tr>

            <tr>
              <th>Gandhi Jayanti</th>
              <td>02/10/2026</td>
              <td>Fri</td>
            </tr>

            <tr>
              <th>Mahalaya</th>
              <td>11/10/2026</td>
              <td>Sun</td>
            </tr>

            <tr>
              <th>Durga Puja / Autumn Break I</th>
              <td>17/10/2026 to 24/10/2026</td>
              <td>Sat - Sat</td>
            </tr>

            <tr>
              <th>Diwali / Chhath / Autumn Break II</th>
              <td>06/11/2026 to 16/11/2026</td>
              <td>Fri - Mon</td>
            </tr>

            <tr>
              <th>Guru Nanak Jayanti</th>
              <td>24/11/2026</td>
              <td>Tue</td>
            </tr>

            <tr>
              <th>Winter Break Phase II</th>
              <td>24/12/2026 to 31/12/2026</td>
              <td>Thu - Thu</td>
            </tr>

          </tbody>
        </table>

        <h2 id='h2'>Reserved - 02 Days | Total Holidays - 90 Days</h2>

       <div className="text-center my-4">
        <a
          href="/Holiday List 2025-26.jpeg"
          className="btn btn-primary"
          download
        >
          Download Holiday List
        </a>
      </div>

      </div>
    </>
  )
}
